module.exports = __webpack_public_path__ + "LS.png?39647eaa29738c313b12ddc61ef71f8f";